import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_get_expired_lotsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lot_expiration_days_before_expiry: number, project_id?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, VendorLot?: { ExpirationDate?: string }, Material?: { ProjectId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lot_expiration_days_before_expiry)) {
      $missingRequiredInParams.push('\'lot_expiration_days_before_expiry\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { lot_expiration_days_before_expiry: number, project_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, VendorLot?: { ExpirationDate?: string }, Material?: { ProjectId?: number } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lot_expiration_days_before_expiry)) {
      $missingRequiredInParams.push('\'lot_expiration_days_before_expiry\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { lot_expiration_days_before_expiry: number, project_id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, VendorLot?: { ExpirationDate?: string }, Material?: { ProjectId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lot_expiration_days_before_expiry)) {
      $missingRequiredInParams.push('\'lot_expiration_days_before_expiry\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lot_expiration_days_before_expiry: number, project_id?: number    }) {
        if(isNil($inParams.lot_expiration_days_before_expiry)) {
          return true; 
        }
      return false;
    }
}
